/* eslint-disable no-use-before-define */
import { gql } from "@apollo/client";

const Asset = `featuredAsset {
  id
  width
  height
  name
  preview
  focalPoint {
    x
    y
    __typename
  }
  __typename
}
`;

const Cart = `
    id
    code
    state
    active
    lines {
      id
      ${Asset}
      unitPrice
      unitPriceWithTax
      quantity
      linePriceWithTax
      discountedLinePriceWithTax
      productVariant {
        id
        name
        __typename
      }
      discounts {
        amount
        amountWithTax
        description
        adjustmentSource
        type
        __typename
      }
      __typename
    }
    totalQuantity
    subTotal
    subTotalWithTax
    total
    totalWithTax
    shipping
    shippingWithTax
    shippingLines {
      priceWithTax
      shippingMethod {
        id
        code
        name
        description
        __typename
      }
      __typename
    }
    discounts {
      amount
      amountWithTax
      description
      adjustmentSource
      type
      __typename
    }
    __typename
`;

export const ADD_TO_CART = gql`
  mutation AddToCart($variantId: ID!, $qty: Int!) {
    addItemToOrder(productVariantId: $variantId, quantity: $qty) {
      __typename

      ... on Order {
        ${Cart}
      }

      ... on InsufficientStockError {
        errorCode
        message
        quantityAvailable
        order {
          ${Cart}
        }
      }

      ... on OrderModificationError {
        errorCode
        message
      }

      ... on OrderLimitError {
        errorCode
        message
        maxItems
      }

      ... on NegativeQuantityError {
        errorCode
        message
      }
    }
  }
`;
